import React from "react";
import { Form } from "react-bootstrap";

const SwitchFrequence = (props) => {
  const { boucle, handleAddRemoveIndice, frequence, arrayFrequence } = props;
  return (
    <div className="d-flex flex-wrap ms-5 border-start">
      {boucle.map((item) => (
        <label className="m-2 p-2 border" key={frequence + item.indice}>
          <Form.Check
            key={item.indice}
            id={frequence + item.indice}
            type="switch"
            label={item.label}
            value={item.indice}
            onChange={(e) => {
              handleAddRemoveIndice(e.target.value);
            }}
            checked={arrayFrequence.includes(item.indice) ? "checked" : ""}
          />
        </label>
      ))}
    </div>
  );
};

export default SwitchFrequence;
